export let slider = ({
  initialItem = 0,
  selector = '#hp-slider',
  transitionSpeed = 1000,
  delayTime = 5000
} = {}) => {
  const opts = {
    initialItem,
    selector,
    transitionSpeed,
    delayTime
  }

  let timer
  let slider = $(opts.selector)
  let items = slider.find('> ul > li')
  let itemsLength = items.length
  let currentItem = opts.initialItem
  let controls = $('.slider-controls')
  const activatedItems = []

  init()

  function init() {
    // pokud je jen jeden item, tak se slider vubec nebude spoustet
    if(itemsLength <= 1)
      return

    showControls()
    // transition: cubic-bezier(0.25, 0.74, 0.57, 1.01);
    // -webkit-transition-timing-function: cubic-bezier(0.25, 0.74, 0.57, 1.01);
    // transition: 1s;

    slider.removeClass('no-js-slider')
    items.css({
      'transition': 'cubic-bezier(0.38, 0.19, 0.36, 1)',
      '-webkit-transition-timing-function': 'cubic-bezier(0.38, 0.19, 0.36, 1)',
      'transition': `${opts.transitionSpeed}ms all`
    })
    // items.css({
    //   'transition': `${opts.transitionSpeed}ms all`
    // })
    activateItem(slider.find(`li:eq(${opts.initialItem})`))
    // slider.find(`li:eq(${opts.initialItem})`).addClass('active')
    changeInInterval()

    // checkSliderOnResize(window.innerWidth)
    // $(window).on('resize', () => {
    //   checkSliderOnResize(window.innerWidth)
    // })

    // zastaveni prokliku kdyz je xxs
    // items.find('a').on('click', function(e) {
    //   if(window.innerWidth <= 480)
    //     e.preventDefault()
    // })
  }

  function activateItem(item) {
    if(activatedItems.indexOf(currentItem) <= -1) {
      const src = item.attr('data-src')
      item.find('img').attr('src', src)
      item.addClass('active')
      activatedItems.push(currentItem)
    } else {
      item.addClass('active')
    }
    // $("<img/>")
    // .on('load', () => {
    //   console.log("image loaded correctly")
    // })
    // .on('error', () => {
    //   console.log("error loading image");
    // })
    // .attr("src", src)
  }

  function checkSliderOnResize(winWidth) {
    // mene nebo rovno nez xxs (xxs = 480px) tak zrusime animaci slideru, protoze to pusobi dost rusive na mobilu
    if(winWidth <= 480)
      stopInterval()
    // a kdyz neni xxs, tak ji znovu rozjedeme na plny pecky, at se z toho ty lidi poserou poradne
    else
      resetInterval()
  }

  function stopInterval() {
    clearInterval(timer)
  }

  function showControls() {
    controls.addClass('show')
  }

  function hideControls() {
    controls.addClass('hide')
  }

  function changeInInterval() {
    timer = setInterval(() => {
      moveNext()
    }, opts.delayTime)
  }

  function resetInterval() {
    clearInterval(timer)
    changeInInterval()
  }

  function moveNext() {
    resetInterval()
    if(++currentItem === itemsLength)
      currentItem = 0

    items.removeClass('active')
    activateItem(slider.find(`li:eq(${currentItem})`))
    // slider.find(`li:eq(${currentItem})`).addClass('active')
  }

  function moveBack() {
    resetInterval()
    if(--currentItem === -1)
      currentItem = itemsLength - 1

    items.removeClass('active')
    activateItem(slider.find(`li:eq(${currentItem})`))
    // slider.find(`li:eq(${currentItem})`).addClass('active')
  }

  slider.find('.back').on('click', () => moveBack())

  slider.find('.next').on('click', () => moveNext())
}



// WEBPACK FOOTER //
// ./src/js/homepage/slider.js